<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on"  @click="$refs.form.reset()">
          {{ $t("btn.News") }}
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false" :loading="$store.getters.overlay">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("btn.News") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="SaveClick" :loading="$store.getters.overlay">
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="4" id="preview">
                  <img v-if="url" :src="url" style="width: 100%;" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-file-input show-size counter label="ภาพปก" required :rules="FileRules" accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera" v-model="FileCover" dense @change="onFileChange" @click:clear="onFileClear" hint="1280 x 850 px" persistent-hint></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-text-field dense label="หัวข้อข่าว" :rules="Rules" v-model="Topic"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <text-editor ref="answersit"></text-editor>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
      
    </v-dialog>


    <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="ClickComplete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import TextEditor from './TextEditor';
  export default {
    components: {
      TextEditor
    },
    data: () => ({
      dialog: false,
      FileCover:null,
      valid:false,
      dialogComplete:false,
      url:null,
      Topic:'',
      FileRules: [
        v => !!v || 'File is required'
      ],
      Rules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      req:{},
    }),
    methods: {
      
      SaveClick() {
        if(this.$refs.form.validate()){
          this.$store.commit('set_overlay',true);
          let formData = new FormData();
          formData.append('FileCover',this.FileCover,this.FileCover.name);
          formData.append('Topic',this.Topic);
          formData.append('Detail',this.$refs.answersit.content);
          formData.append('locale',this.$store.getters.authen.locale);
          this.req.post(this.$store.getters.base_api + 'post-news',formData,{ headers: {'Content-Type': 'multipart/form-data'},})
                .then(response=>{
                  this.dialog = false;
                  this.dialogComplete = true;
                  this.$store.commit('set_overlay',false);
               }).catch(error => {
                  this.$store.commit('set_overlay',true);
              });
        }
      },
      ClickComplete(){
        this.dialogComplete = false;
        this.$emit('complete');
      },
      onFileChange(e) {
        this.url = URL.createObjectURL(e);
      },
      onFileClear(){
        this.url = null;
      },
    },
    mounted() {
      this.req = this.$store.getters.req;
      
    },
  }
</script>